import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=4fe89b99&scoped=true"
import script from "./BackArrow.vue?vue&type=script&lang=ts"
export * from "./BackArrow.vue?vue&type=script&lang=ts"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=4fe89b99&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe89b99",
  null
  
)

export default component.exports